import React, { FC } from "react";
import { ProjectsProps } from "./ContentScreen";
import SectionTitle from "./SectionTitle";
import { getImage, GatsbyImage } from "gatsby-plugin-image";

interface IProject {
  projects: ProjectsProps[];
}

const Projects: FC<IProject> = ({ projects }) => {
  return (
    <div
      id="projects"
      className="w-full md:min-h-screen flex flex-col items-center md:items-start justify-center px-4 md:px-20 py-20"
    >
      <SectionTitle highlight="Take a look at" section="My Projects" />
      <div className="w-full flex flex-col items-center justify-center mt-10">
        <div className="w-full lg:w-4/5 py-10 flex flex-col items-center justify-between overflow-hidden bg-gray-50 rounded-lg">
          {projects.map((project, index) => {
            const imgUrl = getImage(project.image);
            return (
              <div
                key={index}
                className="w-full xl:w-2/3  shadow-md rounded-md my-5 py-5 px-5 flex flex-col items-center md:flex-row  hover:shadow-2xl transition duration-200"
              >
                <div className="w-60">
                  {imgUrl && (
                    <GatsbyImage
                      image={imgUrl}
                      alt={project.name}
                      className="w-full h-32 rounded-md shadow-md"
                    />
                  )}
                </div>
                <div className="flex flex-col items-center md:items-start justify-between ml-10">
                  <h4 className="font-custom font-medium text-2xl">
                    {project.name}
                  </h4>
                  <h5 className="font-custom font-medium text-lg my-1 text-center md:text-left">
                    Technologies Used:{" "}
                    <span className="block md:inline">
                      {project.technologies.map((technology, key) => (
                        <span
                          key={key}
                          className="font-normal text-base text-primary"
                        >
                          {technology},{" "}
                        </span>
                      ))}
                    </span>
                  </h5>
                  <div className="flex items-center mt-5">
                    <a
                      href={project.slug}
                      className="bg-primary px-6 py-1 rounded-md text-lg mr-3 text-white capitalize font-custom"
                    >
                      Live
                    </a>
                    <a
                      href={project.repo}
                      className="bg-primary px-6 py-1 rounded-md text-lg mr-3 text-white capitalize font-custom"
                    >
                      Repo
                    </a>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Projects;
